import { Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { ViewerProps } from 'chat/messages/file/types'
import React, { useState } from 'react'
import { StyleSheet, View } from 'react-native'
import ReactPlayer from 'react-player'

export function VideoViewer({ source }: ViewerProps) {
  const [error, setError] = useState<Error | undefined>()

  const handleError: React.ReactEventHandler<HTMLVideoElement> = event => {
    let errMsg = ''
    if (event && event.nativeEvent) {
      const nativeEvent = event.nativeEvent as Event & {
        type?: string
        target?: HTMLVideoElement
      }
      errMsg = `type: ${nativeEvent.type || 'unknown'}`
      if (
        nativeEvent.target &&
        nativeEvent.target instanceof HTMLVideoElement
      ) {
        errMsg += `, src: ${
          nativeEvent.target.currentSrc || nativeEvent.target.src || 'unknown'
        }`
      }
    } else if (event && event.type) {
      errMsg = `Video error event: ${event.type}`
    } else {
      errMsg = 'Unknown video error'
    }
    const errorMessage = t('videoError') + '\nError: ' + errMsg
    setError(new Error(errorMessage))
  }

  return (
    <View style={styles.container}>
      {error ? (
        <View style={styles.errorContainer}>
          <Text>{error.message}</Text>
        </View>
      ) : null}
      <ReactPlayer
        src={source.uri}
        playing={false}
        controls={true}
        playsInline
        width={'100%'}
        height={'80%'}
        onError={handleError}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'black',
    flex: 1,
    justifyContent: 'center',
  },
  errorContainer: {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    left: 0,
    justifyContent: 'center',
    alignItems: 'center',
    bottom: 0,
    right: 0,
    padding: 10,
    backgroundColor: 'transparent',
  },
})
